// Static sample data for the landing page's DotCalendar mockup.
// Mirrors the real Tracker/Trends DotCalendar (src/screens/TrendsScreen.js)
// visually, but is not wired to Supabase — this is marketing content, not
// a live user's history. 5 rows x 7 cols; `null` = leading blank (the real
// component offsets the grid to align day-of-week), 'empty' = unfilled dot,
// a number = filled dot opacity.
export const DOT_CARDS = [
  {
    key: 'protein',
    label: 'Protein',
    icon: 'meat',
    isNegative: false,
    values: [
      null, null, null, null, null, 1.0, 1.0,
      1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
      1.0, 1.0, 1.0, 1.0, 0.94, 1.0, 1.0,
      1.0, 1.0, 0.77, 1.0, 1.0, 1.0, 1.0,
      1.0, 1.0, 1.0, 1.0, 1.0, 0.75, 0.91,
    ],
  },
  {
    key: 'fiber',
    label: 'Fiber',
    icon: 'wheat',
    isNegative: false,
    values: [
      null, null, null, null, null, 1.0, 0.88,
      1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.74,
      1.0, 0.9, 0.98, 0.89, 0.86, 1.0, 0.56,
      1.0, 1.0, 0.86, 1.0, 1.0, 1.0, 1.0,
      0.91, 1.0, 0.94, 0.98, 1.0, 0.38, 0.77,
    ],
  },
  {
    key: 'alcohol',
    label: 'Alcohol',
    icon: 'wine',
    isNegative: true,
    values: [
      null, null, null, null, null, 'empty', 0.67,
      'empty', 'empty', 'empty', 'empty', 'empty', 0.33, 1.0,
      'empty', 'empty', 'empty', 'empty', 'empty', 'empty', 0.67,
      'empty', 'empty', 0.33, 'empty', 'empty', 0.33, 0.67,
      'empty', 'empty', 'empty', 'empty', 'empty', 'empty', 0.33,
    ],
  },
  {
    key: 'sleep',
    label: 'Disrupted sleep',
    icon: 'moon',
    isNegative: true,
    values: [
      null, null, null, null, null, 'empty', 1.0,
      'empty', 'empty', 'empty', 1.0, 'empty', 1.0, 'empty',
      1.0, 1.0, 1.0, 'empty', 'empty', 'empty', 'empty',
      'empty', 'empty', 'empty', 'empty', 1.0, 1.0, 'empty',
      'empty', 'empty', 'empty', 'empty', 1.0, 'empty', 'empty',
    ],
  },
];
